import React from 'react';
import BlankComponent from "../BlankComponent/BlankComponent";
import PropTypes from 'prop-types';
import {NavLink} from "react-router-dom";

const refrigerantsWidget = (props) => {
  
  const getCoolerInstructionBasedOnPageType = (pageType) => {
    switch (pageType) {
      case 'Perishables':
        return (
          <BlankComponent>
            Coolers for perishables are available at select <NavLink to="/ship/facilities">cargo locations</NavLink>
          </BlankComponent>
        );
      case 'Life Sciences':
        return (
          <BlankComponent>
            Coolers for life science shipments are available at select <NavLink to="/ship/facilities">cargo facilities</NavLink>
          </BlankComponent>
        );
      default:
        return null
    }
  };
  
  return (
    <BlankComponent>
      <h4 className="mbl pbs">Shipping requiring refrigerants</h4>
      <p className="mbl pbs">To keep your perishable shipment cool and fresh, we recommend using a refrigerant</p>
  
  
      <div className="refrigerants-wrapper">
        <div className="refrigerants-item">
          <div className="refrigerants-item-img-wrapper">
            <img src="./assets/icons/flight-status-yellow.svg" alt="Flight status"
                 className="refrigerants-item__img"/>
          </div>
          <div className="refrigerants-item__description">
            Refrigerants should maintain temperature for at least 48 hours
          </div>
        </div>
    
        <div className="refrigerants-item">
          <div className="refrigerants-item-img-wrapper">
            <img src="./assets/icons/dry-ice.png" alt="Dry Ice"
                 className="refrigerants-item__img"/>
          </div>
          <div className="refrigerants-item__description">
            Use chemical coolants such as dry ice or frozen gel packs for refrigerated shipments
          </div>
        </div>
    
        <div className="refrigerants-item">
          <div className="refrigerants-item-img-wrapper">
            <img src="./assets/icons/dry-ice.png" alt="Dry Ice"
                 className="refrigerants-item__img"/>
          </div>
          <div className="refrigerants-item__description refrigerants-item__description-long">
            The maximum amount of dry ice allowed in a package is 5.5 lbs (2.5kg), and it must be shipped in a
            ventilated container. The container should be marked with the words "DRY ICE" and the exact weight of the
            dry ice (1-5.5 lbs). No Dry Ice of any quantity is allowed on international shipments
          </div>
        </div>
    
        <div className="refrigerants-item">
          <div className="refrigerants-item-img-wrapper">
            <img src="./assets/icons/thermometer.png" alt="Thermometer"
                 className="refrigerants-item__img"/>
          </div>
          <div className="refrigerants-item__description">
            {getCoolerInstructionBasedOnPageType(props.pageType)}
          </div>
        </div>
      </div>
    </BlankComponent>
  )
};

export default refrigerantsWidget;

refrigerantsWidget.propTypes = {
  pageType: PropTypes.oneOf([
    "Perishables",
    "Life Sciences"
  ]).isRequired
};




// WEBPACK FOOTER //
// ./src/components/RefrigerantsWidget/RefrigerantsWidget.js